import { __extends, __assign } from 'tslib';
import React__default from 'react';

/**
 * Button Base where anchor or button should be used
 */
var ButtonBase = /** @class */ (function (_super) {
    __extends(ButtonBase, _super);
    function ButtonBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ButtonBase.prototype.render = function () {
        return !this.props.href ? (React__default.createElement("button", __assign({}, this.props))) : (React__default.createElement("a", __assign({}, this.props)));
    };
    return ButtonBase;
}(React__default.Component));

export { ButtonBase as default };
